import React, { useContext } from 'react'
import email from '@assets/images/Advertisement/email.svg'
import mobile1 from '@assets/images/Advertisement/mobile1.png'
import mobile2 from '@assets/images/Advertisement/mobile2.png'
import mobile3 from '@assets/images/Advertisement/mobile3.png'
import mobile4 from '@assets/images/Advertisement/mobile4.png'
import styles from '@shared/components/Advertisement/Advertise.module.scss'
import mDark1 from '@assets/images/Advertisement/darkModeImages/mobile1.png'
import mDark2 from '@assets/images/Advertisement/darkModeImages/mobile2.png'
import mDark3 from '@assets/images/Advertisement/darkModeImages/mobile3.png'
import mDark4 from '@assets/images/Advertisement/darkModeImages/mobile4.png'
import GlobalEventsContext from '@shared/components/global-events/GlobalEventsContext'
import CustomLink from '@shared/components/customLink'
import MyImage from '@shared/components/myImage'

const MobileAd = () => {
  const { stateGlobalEvents } = useContext(GlobalEventsContext)
  return (
    <div className={
      styles.mobileMainDiv
    }
    style={{
      background: 'radial-gradient(at center, rgba(255, 124, 79, 0.70) 9.38%, rgba(248, 124, 79, 0) 70%)'

    }}>
      <MyImage src={stateGlobalEvents?.darkModeEna === 'dark' ? mDark1 : mobile1} alt="Mobile 1"
        className={styles.mobileSize1}
       />
      <MyImage src={stateGlobalEvents?.darkModeEna === 'dark' ? mDark2 : mobile2} alt="Mobile 2" className={styles.mobileSize2} />
      <div className={`${styles.divCard} ${stateGlobalEvents?.darkModeEna === 'dark' ? styles.darkMode : styles.lightMode}`}>
     <span
          className={styles.spanClass}>
          We have saved a spot for you.
        </span>
        <CustomLink href="mailto:hi@oneturf.news" target="_blank">
        <span
          className={styles.spamBox}>
            <MyImage src={email} alt="Mail icon" className={styles.mailMyImage} />
             Email</span></CustomLink>

      </div>

      <MyImage src={stateGlobalEvents?.darkModeEna === 'dark' ? mDark3 : mobile3} alt="Mobile 4" className={styles.mobileSize2} />
      <MyImage src={stateGlobalEvents?.darkModeEna === 'dark' ? mDark4 : mobile4} alt="Mobile 5" className={styles.mobileSize1} />
    </div>

  )
}

export default MobileAd
